import { ComponentType, HTMLAttributes } from "react";

import { DefinedDefaults } from "@/ui/lib/types";
import { getIllustration } from "./Illustration.utils";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const ILLUSTRATION_KEY_MAP = {
  munchAndSnooze: getIllustration(() => import("./illustrations/MunchAndSnooze")),
  chasingYarn: getIllustration(() => import("./illustrations/ChasingYarn")),
  hideInBox: getIllustration(() => import("./illustrations/HideInBox")),
  hangingCat: getIllustration(() => import("./illustrations/HangingCat")),
} as const satisfies Record<string, ComponentType>;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TIllustrationKey = keyof typeof ILLUSTRATION_KEY_MAP;

export type TIllustrationProps = {
  illustration: TIllustrationKey;
} & HTMLAttributes<HTMLDivElement>;

type TIllustrationDefaultProps = DefinedDefaults<
  TIllustrationProps,
  "aria-hidden"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const ILLUSTRATION_DEFAULTS = {
  "aria-hidden": true,
} satisfies TIllustrationDefaultProps;
